<div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown" *ngIf="selectedAverageScoreAccumulator != null">
    <button class="btn btn-sm btn-primary capitalize" id="dropdownManual" ngbDropdownToggle>{{
        selectedAverageScoreAccumulator.alias | translate }} {{ 'scores' | translate }}
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownManual">
        <button (click)="onAverageScoreAccumulatorSelected(averageScoreAccumulator)"
                class="dropdown-item capitalize"
                *ngFor="let averageScoreAccumulator of averageScoreAccumulators">
            {{ averageScoreAccumulator.alias | translate }} {{ 'scores' | translate }}
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/average-score-accumulators/average-score-accumulators.component.html